// This file contains the functions without any dependencies of any other files.
// It is used to avoid circular dependencies.

// TODO: consider to move more utils functions to this file

export const hasValue = (value: unknown) => {
	return value !== undefined && value !== null && value !== '';
};

export const safeParseInt = (value: string): number => {
	if (!hasValue(value)) {
		return null;
	}
	const number = parseInt(value, 10);
	if (Number.isNaN(number)) {
		throw new Error(`string value ${value} is NaN.`);
	}
	return number;
};

export const getUniqueQueryString = (queryString: string, name: string) => {
	const decodedString = decodeURIComponent(queryString);
	const stringWithoutQuestionMark = decodedString.startsWith('?') ? decodedString.slice(1) : decodedString;
	const queryStringHead = `${name}=`;
	const queryStringArray = stringWithoutQuestionMark.split('&').filter((x) => x.startsWith(queryStringHead));
	if (queryStringArray.length === 0) {
		return '';
	}
	if (queryStringArray.length > 1) {
		throw new Error(`The query string can have at most one ${name}`);
	} else {
		return queryStringArray[0].slice(queryStringHead.length);
	}
};
